import { createContext, useContext, useEffect, useState } from 'react'

export type Theme = 'dark' | 'light'

export const ThemeContext = createContext<{
  theme: Theme
  toggleTheme: () => void
  setTheme: (t: Theme) => void
}>({
  theme: 'dark',
  toggleTheme: () => {},
  setTheme: () => {},
})

export function useTheme() {
  return useContext(ThemeContext)
}

export function useThemeState() {
  const [theme, setThemeState] = useState<Theme>(() => {
    try {
      return (localStorage.getItem('jua-theme') as Theme) || 'dark'
    } catch {
      return 'dark'
    }
  })

  const setTheme = (t: Theme) => {
    setThemeState(t)
    try {
      localStorage.setItem('jua-theme', t)
    } catch {}
    document.documentElement.setAttribute('data-theme', t)
  }

  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark')

  // Apply on mount and whenever theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  return { theme, toggleTheme, setTheme }
}
